var render = function render(){var _vm=this,_c=_vm._self._c;return _c('my-profile-menu-layout',[_c('choose-avatar'),_c('change-password',{on:{"loading-change":_vm.updateLoading}}),_c('notification-settings'),_c('authentication-settings'),_c('my-profile-user-limits')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }